import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';

import type { FixedModalProperties } from './FixedModal.types';

export const FixedModal: React.FC<FixedModalProperties> = ({
  dataTest = 'fixed_modal',
  showModal,
  title,
  content,
  buttonLabel,
}) => {
  return (
    <Dialog data-testid={dataTest} open={showModal}>
      <DialogTitle data-testid={`${dataTest}_title`}>{title}</DialogTitle>
      <DialogContent data-testid={`${dataTest}_content`}>
        {content}
      </DialogContent>
      <DialogActions data-testid={`${dataTest}_actions`}>
        <Button>{buttonLabel}</Button>
      </DialogActions>
    </Dialog>
  );
};
